import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const CashOrCardScenario = () => {
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1)
  const [paymentChoice, setPaymentChoice] = useState(null)

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-medium text-blue-100 mb-1">Interaktívny scenár</div>
                <h1 className="text-3xl font-bold">💳 Hotovosť alebo karta?</h1>
              </div>
              {currentStep === 1 ? (
                <button
                  onClick={() => navigate('/scenarios')}
                  className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
                >
                  ← Späť na ročníky
                </button>
              ) : (
                <button
                  onClick={() => setCurrentStep(currentStep - 1)}
                  className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
                >
                  ← Späť
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="bg-white border-b border-gray-200 py-3">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-2">
              {[...Array(13)].map((_, idx) => (
                <div
                  key={idx + 1}
                  className={`flex-1 h-2 rounded-full transition-all ${
                    idx + 1 <= currentStep ? 'bg-blue-500' : 'bg-gray-200'
                  }`}
                />
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-2 text-center">
              Krok {currentStep} z 13
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">


          {/* NEW INTRO SLIDE 1: What this story is about */}
          {currentStep === 1 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">📖</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  O čom bude tento príbeh?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto">
                <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">💰</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Platiť v hotovosti alebo kartou
                      </p>
                      <p className="text-gray-600 text-sm">
                        Obe možnosti používajú peniaze, ale iným spôsobom
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">🤔</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Kedy je lepšie platiť v hotovosti a kedy kartou?
                      </p>
                      <p className="text-gray-600 text-sm">
                        Zistíme, čo je pre Jakuba lepšie v rôznych situáciách
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(2)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* NEW INTRO SLIDE 2: Explain cash and card */}
          {currentStep === 2 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">💶💳</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Čo je hotovosť a čo je karta?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto">
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-3xl">🪙</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Hotovosť = mince a bankovky
                      </p>
                      <p className="text-gray-600 text-sm">
                        Sú to peniaze, ktoré môžeš držať v ruke. Vidíš ich a cítiš ich.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-3xl">💳</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Karta = spôsob platby z tvojich peňazí v banke
                      </p>
                      <p className="text-gray-600 text-sm">
                        Karta používa tvoje peniaze, ktoré máš uložené v banke. Nie sú to nové peniaze!
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">⚠️</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Dôležité
                      </p>
                      <p className="text-gray-600 text-sm">
                        Keď platíš kartou, používaš svoje vlastné peniaze. Ak nemáš peniaze v banke, karta nebude fungovať.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(3)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* NEW INTRO SLIDE 3: Explain terminal */}
          {currentStep === 3 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">🖥️</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Čo je terminál?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto">
                <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-3xl">🖥️</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Terminál = prístroj v obchode na platenie kartou
                      </p>
                      <p className="text-gray-600 text-sm">
                        Keď priložíš kartu k terminálu alebo ju vložíš, terminál pomáha spracovať platbu.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">✅</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Ako funguje terminál?
                      </p>
                      <p className="text-gray-600 text-sm">
                        Priložíš kartu → terminál pípne → peniaze sa odpočítajú z tvojho účtu v banke → platba je hotová
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">❌</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Čo keď nie sú peniaze na účte?
                      </p>
                      <p className="text-gray-600 text-sm">
                        Ak nemáš dostatok peňazí v banke, platba kartou nebude fungovať.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(4)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Začnime príbeh
                </button>
              </div>
            </div>
          )}

          {/* ORIGINAL Step 1 (now Step 4): Observing parent */}
          {currentStep === 4 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🛒</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  V obchode s mamou
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Jakub ide s mamou do obchodu. Mama kúpi chlieb a mlieko.
                </p>
                <p className="text-gray-700 mb-3">
                  V prvom obchode mama platí <strong>bankovkami a mincami</strong> 💶🪙.
                </p>
                <p className="text-gray-700">
                  V druhom obchode mama priloží <strong>kartu k terminálu</strong> 💳 a znie pípnutie.
                </p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💭 Jakub sa zamyslí: "Prečo mama niekedy platí peniazmi a niekedy kartou? Je to to isté?"
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(5)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 2: What is cash? */}
          {currentStep === 5 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💵</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Čo je hotovosť?
                </h2>
              </div>

              <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Hotovosť</strong> sú peniaze, ktoré môžeš držať v ruke.
                </p>
                <p className="text-gray-700 mb-4">
                  Sú to <strong>mince</strong> 🪙 (kovové) a <strong>bankovky</strong> 💶 (papierové).
                </p>
                <p className="text-gray-700">
                  Keď máš 10 eur v peňaženke, presne vidíš, koľko máš. Môžeš si ich spočítať.
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div className="bg-orange-50 border-2 border-orange-300 rounded-xl p-6 text-center">
                  <div className="text-5xl mb-3">🪙</div>
                  <div className="font-bold text-gray-800 mb-2">Mince</div>
                  <p className="text-sm text-gray-600">1€, 2€, 50 centov...</p>
                </div>

                <div className="bg-green-50 border-2 border-green-300 rounded-xl p-6 text-center">
                  <div className="text-5xl mb-3">💶</div>
                  <div className="font-bold text-gray-800 mb-2">Bankovky</div>
                  <p className="text-sm text-gray-600">5€, 10€, 20€, 50€...</p>
                </div>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
                <p className="text-gray-700 font-semibold text-center">
                  💡 "Čo držím v ruke, to míňam."
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(6)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 3: What is a card? */}
          {currentStep === 6 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💳</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Čo je platobná karta?
                </h2>
              </div>

              <div className="bg-purple-50 border-l-4 border-purple-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Platobná karta</strong> je malý plastový obdĺžnik, ktorý máš v peňaženke.
                </p>
                <p className="text-gray-700 mb-3">
                  Ale samotná karta <strong>nie sú nové peniaze</strong>! Karta len ukazuje banke, že máš na účte peniaze.
                </p>
                <p className="text-gray-700">
                  Tvoje peniaze sú uložené v <strong>banke</strong> 🏦, nie v karte.
                </p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-6">
                <h3 className="font-bold text-gray-900 mb-3">Ako to funguje?</h3>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">1.</span>
                    <span>Mama zarobí peniaze v práci</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">2.</span>
                    <span>Peniaze prídu na jej účet v banke</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">3.</span>
                    <span>Keď priloží kartu, banka odošle peniaze do obchodu</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">4.</span>
                    <span>Na účte ostane menej peňazí</span>
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
                <p className="text-gray-700 font-semibold text-center">
                  💡 "Karta nie sú nové peniaze, len tie moje v banke."
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(7)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 4: Key difference - visibility */}
          {currentStep === 7 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">🤔</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Aký je rozdiel?
                </h2>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div className="bg-green-50 border-2 border-green-300 rounded-xl p-6">
                  <div className="text-4xl mb-3 text-center">💵</div>
                  <h3 className="font-bold text-gray-800 mb-3 text-center">S hotovosťou</h3>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <span className="text-green-600">✓</span>
                      <span>Vidíš, koľko ti ostalo</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600">✓</span>
                      <span>Môžeš si peniaze spočítať</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600">✓</span>
                      <span>Keď míňaš, peňaženka je ľahšia</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-purple-50 border-2 border-purple-300 rounded-xl p-6">
                  <div className="text-4xl mb-3 text-center">💳</div>
                  <h3 className="font-bold text-gray-800 mb-3 text-center">S kartou</h3>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600">•</span>
                      <span>Nevidíš peniaze</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600">•</span>
                      <span>Musíš si pamätať, koľko míňaš</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600">•</span>
                      <span>Ľahšie míňať viac, než plánuješ</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 font-semibold mb-2">⚠️ Dôležité:</p>
                <p className="text-gray-700">
                  Ak na účte nie sú peniaze, <strong>karta nebude fungovať</strong>! Karta sama osebe nie je zdroj peňazí.
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(8)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 5: Situation setup */}
          {currentStep === 8 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🎒</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Tvoja situácia
                </h2>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Dostaneš od rodičov <strong className="text-yellow-600">10 eur</strong> na školské potreby.
                </p>
                <p className="text-gray-700 mb-3">
                  Potrebuješ kúpiť:
                </p>
                <ul className="space-y-2 text-gray-700 ml-4">
                  <li>• Zošity (3 €)</li>
                  <li>• Pero (2 €)</li>
                  <li>• Pravítko (1 €)</li>
                  <li>• Gumu (0,50 €)</li>
                </ul>
                <p className="text-gray-700 mt-3">
                  Spolu: <strong>6,50 €</strong>
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg">
                <p className="text-gray-700 mb-3">
                  Rodičia ti ponúkajú dve možnosti:
                </p>
                <p className="text-gray-700">
                  <strong>A)</strong> Dostaneš 10 € v hotovosti (bankovky a mince)<br />
                  <strong>B)</strong> Dostaneš kartu s 10 € na účte
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(9)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Rozhodnúť sa
                </button>
              </div>
            </div>
          )}

          {/* Step 6: Decision - cash or card? */}
          {currentStep === 9 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🤷</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Ako chceš platiť?
                </h2>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 text-sm">
                  💡 Obidve možnosti majú rovnako 10 €. Rozdiel je v tom, ako ľahko budeš vedieť sledovať, koľko ti ostalo.
                </p>
              </div>

              <div className="space-y-4">
                <button
                  onClick={() => {
                    setPaymentChoice('cash')
                    setCurrentStep(10)
                  }}
                  className="w-full p-6 bg-gradient-to-r from-green-50 to-green-100 rounded-xl border-2 border-green-300 hover:border-green-500 hover:shadow-lg transition-all text-left"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-5xl">💵</span>
                    <div>
                      <div className="text-xl font-bold text-gray-800 mb-1">Hotovosť (10 €)</div>
                      <p className="text-sm text-gray-600">Dostaneš bankovky a mince</p>
                    </div>
                  </div>
                </button>

                <button
                  onClick={() => {
                    setPaymentChoice('card')
                    setCurrentStep(11)
                  }}
                  className="w-full p-6 bg-gradient-to-r from-purple-50 to-purple-100 rounded-xl border-2 border-purple-300 hover:border-purple-500 hover:shadow-lg transition-all text-left"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-5xl">💳</span>
                    <div>
                      <div className="text-xl font-bold text-gray-800 mb-1">Karta (10 € na účte)</div>
                      <p className="text-sm text-gray-600">Dostaneš platobnú kartu</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          )}

          {/* Step 7: Consequence - Chose cash */}
          {currentStep === 10 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💵</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Platba v hotovosti
                </h2>
              </div>

              <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Máš v peňaženke <strong>10 €</strong>: jednu bankovku 10 € alebo 2 bankovky po 5 €.
                </p>
                <p className="text-gray-700">
                  Ideš do papiernictva a vyberáš veci. Pred pokladňou si vyberieš bankovky a mince a zaplatíš <strong>6,50 €</strong>.
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Čo sa stalo?</strong>
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li>✅ Videl si presne, koľko si dal predavačke</li>
                  <li>✅ Dostal si naspäť <strong>3,50 €</strong> (drobné)</li>
                  <li>✅ Teraz vidíš v peňaženke, že ti ostalo 3,50 €</li>
                  <li>✅ Môžeš si peniaze spočítať a presne vieš, na čo ich môžeš použiť</li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💡 S hotovosťou si presne videl, koľko si minul a koľko ti ostalo. Je ľahšie sledovať svoje míňanie!
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 8: Consequence - Chose card */}
          {currentStep === 11 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">💳</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Platba kartou
                </h2>
              </div>

              <div className="bg-purple-50 border-l-4 border-purple-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Máš kartu s <strong>10 €</strong> na účte v banke.
                </p>
                <p className="text-gray-700">
                  Ideš do papiernictva a vyberáš veci. Pri pokladni priložíš kartu k terminálu. Zaznie <strong>pípnutie</strong> ✓ a zaplatené!
                </p>
              </div>

              <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Čo sa stalo?</strong>
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li>⚠️ Nevidel si peniaze – len si priložil kartu</li>
                  <li>⚠️ Banka odoslala 6,50 € do obchodu</li>
                  <li>⚠️ Na účte ti ostalo <strong>3,50 €</strong>, ale ty to nevidíš</li>
                  <li>⚠️ Musíš si zapamätať alebo neskôr pozrieť v banke, koľko ti ostalo</li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💡 S kartou je platenie rýchle a jednoduché, ale nevidíš hneď, koľko ti ostalo. Musíš si dávať väčší pozor, aby si neminul viac, než máš!
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 9: What did you learn? */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">✨</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Čo si sa naučil?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto mb-8">
                <div className="bg-green-50 border-l-4 border-green-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">1. Hotovosť vs. karta</h3>
                  <p className="text-gray-700 text-sm">
                    Hotovosť držíš v ruke. Karta ukazuje banke, že máš peniaze na účte. Karta sama nie sú nové peniaze!
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">2. Viditeľnosť míňania</h3>
                  <p className="text-gray-700 text-sm">
                    S hotovosťou vidíš, koľko ti ostalo. S kartou musíš viac premýšľať a sledovať, koľko míňaš.
                  </p>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">3. Karta bez peňazí nefunguje</h3>
                  <p className="text-gray-700 text-sm">
                    Ak na účte nie sú peniaze, karta nebude fungovať. Karta nie je zázračná – je to len nástroj na použitie peňazí z banky.
                  </p>
                </div>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-6">
                <h3 className="font-bold text-gray-900 mb-3 text-center">💡 Zapamätaj si:</h3>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li className="text-center font-semibold">"Čo držím v ruke, to míňam."</li>
                  <li className="text-center font-semibold">"Karta nie sú nové peniaze, len tie moje v banke."</li>
                </ul>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(13)}
                  className="px-8 py-4 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition"
                >
                  Ukončiť
                </button>
              </div>
            </div>
          )}

          {/* Step 10: Final discussion */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center">
              <div className="text-6xl mb-6">🎉</div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Scenár dokončený!
              </h2>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg max-w-2xl mx-auto mb-8">
                <h3 className="font-bold text-gray-900 mb-4">💬 Diskusia do triedy:</h3>
                <ul className="space-y-3 text-sm text-gray-700 text-left">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Videl si rodičov platiť kartou? Ako to vyzeralo?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Prečo je dobré vedieť, koľko peňazí ti ostalo?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Čo by sa stalo, keby si sa snažil platiť kartou, ale na účte by neboli peniaze?</span>
                  </li>
                </ul>
              </div>

              <div className="flex gap-4 justify-center">
                <button
                  onClick={() => {
                    setCurrentStep(1)
                    setPaymentChoice(null)
                  }}
                  className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition"
                >
                  🔄 Skúsiť znova
                </button>
                <button
                  onClick={() => navigate('/scenarios')}
                  className="px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition"
                >
                  Späť na ročníky
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  )
}

export default CashOrCardScenario
